export const getIntervalFunction = (min: number, max: number) => (ratio: number) => min + (max - min) * ratio;
